<template>
    <div class="connectionContainer">
        <div class="connectionHeader">
            <div class="modal_title"> 商品グループ個数集計設定</div>
        </div>
        <div class="connectionContents">
            <div class="modal_body">
                <div class="modal_form">
                    <h3>{{ this.totallingTargetName }}</h3>
                    <p>個数を集計する商品のみチェックをつけてください</p>
                    <template v-for="(tt, index) in totallingTarget ">
                        <div class="modal_input" v-bind:key="tt.product_id"
                            v-if="index === 0 || tt.product_id !== totallingTarget[index - 1].product_id">
                            <label>
                                <input type="checkbox" v-model="tt.units_count_flg" @change="handleUnitsCountChange(tt)">
                                【{{ tt.product_id }}<Icon v-if="tt.set_product_id" title="セット商品">dice-multiple-outline
                                </Icon>】{{ tt.name }}
                            </label>
                        </div>
                        <div v-if="tt.set_product_id" class="set_product"
                            v-bind:key="tt.set_product_id + tt.set_detail_product_id">
                            <label>
                                <input type="checkbox" v-model="tt.set_units_count_flg" :disabled="!tt.units_count_flg"
                                    @change="handleUnitsCountChangeDetail(tt.set_product_id)">
                                【{{ tt.set_detail_product_id }}】{{ tt.set_name }}
                            </label>
                        </div>
                    </template>
                </div>
                <div class="modal_submit">
                    <Button width="100px" @click="updateUnitsCount">更新</Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        totallingTargetId: Number,
        totallingTargetName: String,
    },
    data() {
        return {
            totallingTarget: {},
        }
    },
    mounted: function () {
        //対象の商品グループ情報取得
        this.getTotallingTarget();
    },
    methods: {
        //初期処理（対象の商品グループ情報取得）
        getTotallingTarget: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/totallingTargetProducts/" + this.totallingTargetId)
                .then((res) => {
                    this.totallingTarget = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        //更新ボタンクリック時処理
        updateUnitsCount: function () {
            this.$store.dispatch("loading", true);
            const data = {};
            let flg = 0;
            let setflg = 0;

            this.totallingTarget.forEach((tt, index) => {

                if (tt.units_count_flg) {
                    flg = 0;
                }
                else {
                    flg = 1;
                }


                if (tt.set_units_count_flg) {
                    setflg = 0
                }
                else {
                    setflg = 1;
                }


                data[index] = {
                    productId: tt.product_id,
                    ucFlg: flg,
                    setDetailProductId: tt.set_detail_product_id,
                    setucFlg: setflg,
                };
            });

            this.axios.put("/api/totallingTargetProducts/" + this.totallingTargetId, data)
                .then(() => {
                    this.modalClose();
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },


        //商品（セット商品）のチェックボックス変更時処理
        handleUnitsCountChange(tt) {
            if (!tt.units_count_flg) {
                this.setAllSetUnitsCountFlgToFalse(tt.set_product_id);
            }
            else {
                this.setAllSetUnitsCountFlgToTrue(tt.set_product_id);
            }
        },


        //セット商品に属する商品のチェックボックス変更時処理
        handleUnitsCountChangeDetail(setProductId) {

            if (setProductId !== null) {
                //セット商品に属する商品全てのチェック状態を取得
                //チェックされている：0
                //チェックされていない：1
                let chkFlg = [];

                this.totallingTarget.forEach(tt => {
                    if (tt.set_product_id === setProductId) {

                        if (!tt.set_units_count_flg) {
                            chkFlg.push(1);
                        } else {
                            chkFlg.push(0);
                        }
                    }
                });

                //セット商品に属する商品全てのチェック状態のうち、チェックされているものがあるかチェック
                let chkFlg2 = 1;

                chkFlg.forEach(cf => {
                    if (cf === 0) {
                        chkFlg2 = 0;
                    }
                });

                //セット商品に属する商品のチェックがすべて外されていたら、セット商品自体のチェックも外す
                if (chkFlg2 === 1) {
                    this.setAllSetUnitsCountFlgToFalse(setProductId);
                }
            }
        },


        //セット商品のチェックをすべて外す
        setAllSetUnitsCountFlgToFalse(setProductId) {
            this.totallingTarget.forEach(tt => {
                if (setProductId !== null && tt.set_product_id === setProductId) {
                    tt.units_count_flg = false;
                    tt.set_units_count_flg = false;
                }
            });
        },


        //セット商品すべてにチェックする
        setAllSetUnitsCountFlgToTrue(setProductId) {
            this.totallingTarget.forEach(tt => {
                if (setProductId !== null && tt.set_product_id === setProductId) {
                    tt.units_count_flg = true;
                    tt.set_units_count_flg = true;
                }
            });
        },


        //データを再取得してこのモーダルを閉じる
        //親メソッド（AdAccount.vue）で実行
        modalClose() {
            this.$emit('modalClosed');
            this.$store.dispatch("successful", false);
        }
    }
}
</script>


<style scoped lang="sass">
.connectionContainer
    height: 100%
    width: 100%
    margin: 0
    padding: 10px
    display: inline-grid
    grid-template-rows: 40px 1fr 40px
    grid-row-gap: 10px
    .connectionHeader
        display: flex
        align-items: center
        font-size: 1.5rem
        justify-content: center
        .modal_title
            font-size: 1.8rem
    .connectionContents
        display: inline-grid
        overflow: auto
        .modal_form
            padding: 32px
            h3
                font-size: 1.6rem
                font-weight: 700
                margin-bottom: 20px
            p
                font-size: 1.4rem
                margin-bottom: 24px
            .modal_input
                margin-bottom: 30px
                display: flex
                justify-content: start
                align-items: center
                label
                    font-size: 1.4rem
                    width: 50%

                input
                    &:focus
                        outline: 2px solid $mainColor
        .modal_submit
            display: flex
            justify-content: center
.set_product
    margin-left: 30px
    margin-bottom: 30px
    label
        font-size: 1.4rem
        width: 50%
</style>
